let isShow = false;
const nav = document.querySelector('.js-nav');
const overlay = document.querySelector('.js-overlay');

// ドロワーメニューを表示する
const showDrawerMenu = () => {
  nav.classList.add('is-show');
  overlay.classList.add('is-show');
  isShow = true;
}

// ドロワーメニューを非表示にする
const hideDrawerMenu = () => {
  nav.classList.remove('is-show');
  overlay.classList.remove('is-show');
  isShow = false;
}

// ドロワーメニューの表示と非表示を切り替える
const toggleDrawerMenu = () => {
  if (!isShow) {
    showDrawerMenu();
  } else {
    hideDrawerMenu();
  }
}

const hamburgers = document.querySelectorAll('.js-hamburger');
// ハンバーガーアイコンにクリックイベントを追加して、ドロワーメニューの表示と非表示を切り替える
hamburgers.forEach((hamburger) => {
  hamburger.addEventListener('click', () => {
    toggleDrawerMenu();
  });
});

// オーバーレイ（ドロワーメニューを閉じるための領域）にクリックイベントを追加して、ドロワーメニューを閉じる
overlay.addEventListener('click', () => {
  toggleDrawerMenu();
});